export const EmployeesQueryFieldOptions = [
    'total_employees_r2016_company',
    'total_employees_r2016_cnpj',
];
export const RevenuesQueryFieldOptions = [
    'revenue_a32_cnpj_code',
    'revenue_a32_company_code',
];
